import * as types from "../actions/ActionTypes";

const defaultState = {
  open: false,
  isOnBoarded: false
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.ONBOARDING_OPEN:
      return Object.assign({}, state, {
        open: true
      });

    case types.ONBOARDING_CLOSE:
      return Object.assign({}, state, {
        open: false
      });

    default:
      return state;
  }
}
